export const SUCCEED = 'SUCCEED';

export const BEZAHL_DE = 'BEZAHL_DE';
const KIOSK_INTEGRATION = 'KIOSK_INTEGRATION';

/**
 * Single source of truth for the payment status in the BO. `PRE_AUTHORIZED` is the intermediate
 * state of two-step providers (BMW Pay): funds are authorized but not yet captured.
 *
 * TODO: replace the mirror by a re-export once @arhs-fleetback/types exposes it — the enum lives in
 * `entities/payments/enums` and the barrel re-exports it, but `./entities/payments` is absent from
 * the package `exports` map, so the subpath cannot be imported (checked on 0.0.71).
 */
export const PaymentStatus = {
  ABORTED: 'ABORTED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PRE_AUTHORIZED: 'PRE_AUTHORIZED',
  SUCCESS: 'SUCCESS'
} as const;

export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];

export const SETTLED_PAYMENT_STATUS: PaymentStatus[] = [
  PaymentStatus.PRE_AUTHORIZED,
  PaymentStatus.SUCCESS
];

export const PAYMENT_TYPE = {
  DEPOSIT: 'DEPOSIT',
  FINAL_INVOICE: 'FINAL_INVOICE',
  FULL: 'FULL',
  EXTERNAL: 'EXTERNAL'
} as const;

export type PaymentType = typeof PAYMENT_TYPE[keyof typeof PAYMENT_TYPE];

export const DEFAULT_PAYMENT_STATUS = [SUCCEED];

export const PAYMENT_PROVIDER = {
  BMW_PAY: 'BMW_PAY',
  BUMPER: 'BUMPER',
  INGENICO: 'INGENICO',
  NETS: 'NETS',
  NEXI: 'NEXI',
  SPENSE: 'SPENSE',
  STRIPE: 'STRIPE',
  SWEDBANK_PAY: 'SWEDBANK_PAY'
};

export const PAYMENT_GATEWAY = {
  BEZAHL_DE
};
export const ALL_PAYMENT_GATEWAY = {
  BEZAHL_DE,
  KIOSK_INTEGRATION
};
